var CreditCardFormModule = /** @class */ (function () {
    function CreditCardFormModule() {
    }
    return CreditCardFormModule;
}());
export { CreditCardFormModule };
